"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormattedNumber = getFormattedNumber;
var _constants = require("../constants");
var _formatFractionalPart = require("./formatFractionalPart");
var _formatWholeNumberPart = require("./formatWholeNumberPart");
var _replacePattern = require("./replacePattern");
var _round = require("./round");
/**
 * Formats general number based on given parameters.
 * The rounded absolute value of the parameter `value` is split into two parts, a whole number part and a fractional part,
 * and each part is formatted separately. Then, both formatted parts are joined together.
 *
 * @param value Value to format
 * @param decimals Number of decimals
 * @param decimalSeparator Decimal separator character
 * @param groupSizes Sizes of groups
 * @param groupSeparator Group separator character
 * @param options Additional formatting options
 * @returns Formatted general number
 */
// eslint-disable-next-line max-params -- needed for formatting
function getFormattedNumber(value, decimals, decimalSeparator, groupSizes, groupSeparator, options) {
  // Note: standard JS rounding
  // If the fractional portion is exactly 0.5, the argument is rounded to the next integer in the direction of +∞.
  // This differs from many languages' round() functions, which often round half-increments away from zero.
  // Because of this difference, the absolute value is used and the negative sign is added at the end, so it is compatible with BE!

  // round and split the absolute value of the value to whole number and fractional parts
  // the value will be formatted without the negative symbol
  const [wholeNumberPart, fractionalPart] = (0, _round.round)(Math.abs(value), decimals).toFixed(decimals).split(_constants.SEPARATORS.DOT);

  // format each number part separately
  const formattedValue = [(0, _formatWholeNumberPart.formatWholeNumberPart)(wholeNumberPart, groupSizes, groupSeparator), (0, _formatFractionalPart.formatFractionalPart)(fractionalPart, options?.removeTrailingZeros)].filter(Boolean).join(decimalSeparator);

  // add negative symbol
  if (formattedValue && value < 0 && options?.negativePattern) {
    return (0, _replacePattern.replacePattern)(options.negativePattern, {
      n: formattedValue
    });
  }
  return formattedValue;
}
